import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import {
  required,
  maxLength,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import upLoad from '@/assets/img/upload_photo3.jpg';
import store from '@/store';
import axios from 'axios';
import Vue from 'vue';

const getTodayDateString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default {
  name: "paymentEdit",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },
  data() {
    return {
      config: CONFIG,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      inputData: {
        class_id: "",
        student_id: "",
        guardian1_name: "",
        item_id: "",
        discount_type: null,
        discount_amount: null,
        discount_note: "",
        showDiscount: false,
        gross_total_amt: 0,
        net_total_amt: 0,
        quantity: 1,
      },
      paymentData: {
        class_id: "",
        student_id: "",
        guardian1_name: "",
        is_discount: 0,
        discount_type: null,
        discount_amount: null,
        gross_total_amt: 0,
        net_total_amt: 0,
        due_date: "",
        tax: 0,
        grand_total_amt: 0,
        receiver:
          store.state.user.name || localStorage.getItem("user_name") || "",
      },
      paymentDetail: [],
      editData: [],
      originalQuantities: {},
      loginId: store.state.user.id,
      ssImage: "",
      addItem: false,
      campusId: store.state.user.campus_id,
      paymentMethodArr: null,
      isLoading: false,
      upLoad,
      disabled: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      submitted: false,
      studentId: null,
      imgRemove: false,
      guardian1_name: "",
      student_name: "",
      visible: false,
      itemArr: [],
      itemAmtArr: [],
      classArr: [],
      class_name: "",
      discountPercent: "",
      discountFixAmount: "",
      discountError: "",
      paymentDiscountError: "",
      discountPercentageAmount: 0,
      taxRateValue: 0,
      maxQuantity: 999,
      academicYearArr: [],
      gradeArr: [],
      academicYearId: "",
      gradeId: "",
      disabledForm: false,
      submitting: false,
      academic_year_name: "",
      grade_name: "",
      clonedOnce: false,
    };
  },

  validations() {
    const isValidDiscount = (value) => {
      const netTotalAmt = this.inputData?.gross_total_amt || 0;
      return (
        value === null ||
        value === undefined ||
        (value >= 0 && value <= netTotalAmt)
      );
    };

    const isValidPaymentDiscount = (value) => {
      const netTotalAmt = this.netTotalSum || 0;
      return (
        value === null ||
        value === undefined ||
        (value >= 0 && value <= netTotalAmt)
      );
    };

    const isInteger = (value) => {
      return value === null || value === undefined || Number.isInteger(Number(value));
    };

    const isPositiveInteger = (value) =>
      value === null || value === undefined || (Number.isInteger(Number(value)) && Number(value) > 0);

    // const notPastDate = (value) => {
    //   if (!value) return true;
    //   const today = getTodayDateString();
    //   return value >= today;
    // };

    return {
      inputData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        item_id: {
          required,
        },
        gross_total_amt: {
          required,
        },
        net_total_amt: {
          required,
        },
        quantity: {
          required,
          isPositiveInteger,
          maxValue: maxValue(this.maxQuantity),
        },
        discount_amount: {
          isValidDiscount,
          isInteger,
        },
        discount_note: {
          maxLength: maxLength(1000),
        },
      },
      paymentData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        gross_total_amt: {
          required,
        },
        discount_amount: {
          isValidPaymentDiscount,
          isInteger,
        },
        net_total_amt: {
          required,
          minValue: minValue(0),
        },
        due_date: {
          required,
        },
        receiver: {
          maxLength: maxLength(100),
        },
      },
    };
  },

  methods: {
    getTodayDate() {
      return getTodayDateString();
    },
    sanitizePositiveInteger(value) {
      const matched = String(value ?? '').match(/-?\d+(\.\d+)?/);
      if (!matched) return 1;
      const parsed = Math.floor(Math.abs(Number(matched[0])));
      return isNaN(parsed) || parsed <= 0 ? 1 : parsed;
    },
    parseNumericInput(value) {
      const cleaned = String(value ?? "").replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    resetInputData() {
      const preservedValues = {
        class_id: this.inputData.class_id,
        student_id: this.inputData.student_id,
        guardian1_name: this.inputData.guardian1_name,
      };
      this.inputData = {
        ...preservedValues,
        item_id: "",
        discount_type: null,
        discount_amount: null,
        discount_note: "",
        showDiscount: false,
        gross_total_amt: 0,
        net_total_amt: 0,
        quantity: 1,
      };
    },

    toggleDiscount() {
      this.inputData.showDiscount = !this.inputData.showDiscount;
      if (!this.inputData.showDiscount) {
        this.inputData.discount_amount = 0;
        this.inputData.discount_type = null;
        this.inputData.discount_note = "";
        this.discountError = "";
        this.calculateNetTotal();
      }
    },

    getItem(acdYearId) {
      if (!acdYearId) {
        return;
      }
      axios
        .get("item/getItemForPayment", {
          params: { acd_year_id: acdYearId },
        })
        .then((res) => {
          this.itemArr = (res.data.data || []).map(item => ({
            id: item.id,
            text: item.item_name || item.p_item_name || item.name || item.text || String(item)
          }));
          this.itemAmtArr = res.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    getAmt(item_id) {
      var selectedItem = (this.itemAmtArr || []).find(
        (item) => item && item.id == item_id,
      );
      if (!selectedItem) {
        this.inputData.net_total_amt = 0;
        this.inputData.gross_total_amt = 0;
        return;
      }
      const quantity = this.sanitizePositiveInteger(this.inputData.quantity);
      this.inputData.net_total_amt = selectedItem.p_item_amount * quantity;
      this.inputData.gross_total_amt = selectedItem.p_item_amount * quantity;
    },

    calculateNetTotalForDetail(item) {
      if (!item.quantity || Number(item.quantity) < 1) {
        item.quantity = 1;
      }
      if (Number(item.quantity) > this.maxQuantity) {
        item.quantity = this.maxQuantity;
      }
      const quantity = this.sanitizePositiveInteger(item.quantity);
      const selectedItem = (this.itemAmtArr || []).find(
        (i) => i && i.id == item.item_id,
      );
      const baseAmount = selectedItem ? selectedItem.p_item_amount * quantity : 0;
      item.gross_total_amt = baseAmount;

      let discountAmount = this.parseNumericInput(item.discount_amount);

      if (item.discount_type == 1) {
        if (item.gross_total_amt != 0 && discountAmount > item.gross_total_amt) {
          discountAmount = 0;
        }
        item.net_total_amt = item.gross_total_amt - discountAmount;
      } else if (item.discount_type == 2) {
        if (discountAmount > 100) {
          discountAmount = 100;
        }
        const discount = (item.gross_total_amt * discountAmount) / 100;
        item.net_total_amt = item.gross_total_amt - discount;
      } else {
        item.net_total_amt = item.gross_total_amt;
      }
      if (item.net_total_amt < 0) item.net_total_amt = 0;
    },

    calculateNetTotal() {
      if (!this.inputData.quantity || Number(this.inputData.quantity) < 1) {
        this.inputData.quantity = 1;
      }
      if (Number(this.inputData.quantity) > this.maxQuantity) {
        this.inputData.quantity = this.maxQuantity;
      }
      let discountAmount = this.parseNumericInput(
        this.inputData.discount_amount,
      );
      this.discountError = "";
      if (discountAmount < 0) {
        this.discountError = "Discount amount cannot be negative.";
        discountAmount = 0;
      }
      const quantity = this.sanitizePositiveInteger(this.inputData.quantity);
      const selectedItem = (this.itemAmtArr || []).find(
        (item) => item && item.id == this.inputData.item_id,
      );
      const baseAmount = selectedItem ? selectedItem.p_item_amount * quantity : 0;
      this.inputData.gross_total_amt = baseAmount;

      if (this.inputData.discount_type == 1) {
        if (
          this.inputData.gross_total_amt != 0 &&
          discountAmount > this.inputData.gross_total_amt
        ) {
          this.discountError = "Discount amount cannot exceed gross total.";
          discountAmount = 0;
        }
        this.inputData.net_total_amt =
          this.inputData.gross_total_amt - discountAmount;
      } else if (this.inputData.discount_type == 2) {
        if (discountAmount > 100) {
          this.inputData.discount_amount = 100;
        }
        const discount =
          (this.inputData.gross_total_amt * discountAmount) / 100;
        this.inputData.net_total_amt =
          this.inputData.gross_total_amt - discount;
      } else {
        this.inputData.net_total_amt = this.inputData.gross_total_amt;
      }
      if (this.inputData.net_total_amt < 0) this.inputData.net_total_amt = 0;
    },

    onItemChange() {
      this.getAmt(this.inputData.item_id);
      this.calculateNetTotal();
    },

    getDetail() {
      this.isLoading = true;
      const request = {
        params: {
          campus_id: this.campusId,
          class_id: this.$route.params.classId,
        },
      };
      return axios
        .get(`payment/editDetail/${this.$route.params.invoiceId}`, request)
        .then((res) => {
          if (!res.data || !res.data.payment_data) {
            this.studentId = null;
            return;
          }
          const data = res.data;
          this.inputData.class_id = data.class_id;
          this.inputData.student_id = data.student_id;
          this.inputData.guardian1_name = data.guardian1_name;
          const initialReceiver = this.paymentData.receiver;
          this.paymentData = data.payment_data;
          this.paymentData.receiver = data.payment_data.receiver || initialReceiver;
          this.paymentDetail = (data.payment_details || []).map((detail) => ({
            ...detail,
            quantity: detail.quantity || 1,
          }));
          this.originalQuantities = {};
          this.paymentDetail.forEach((d) => {
            this.originalQuantities[d.item_id] = d.quantity;
          });
          this.studentId = data.student_id;
          this.student_name = data.student_name;
          this.guardian1_name = data.guardian1_name;
          this.class_name = data.class_name;
          this.grade_name = data.grade_name || "";
          this.academic_year_name = data.acd_year_name || "";
          this.disabledForm = true;

          if (!this.paymentData.due_date) {
            this.paymentData.due_date = getTodayDateString();
          }

          if (data.acd_year_id) {
            this.getItem(data.acd_year_id);
          }

          if (this.paymentData.tax != null) {
            this.paymentData.tax = parseFloat(this.paymentData.tax) || 0;
          }
          if (this.paymentData.grand_total_amt != null) {
            this.paymentData.grand_total_amt = parseFloat(this.paymentData.grand_total_amt) || 0;
          }

          const discType = this.paymentData.discount_type;
          const discAmt = parseFloat(this.paymentData.discount_amount) || 0;
          const grossTotal = parseFloat(this.paymentData.gross_total_amt) || 0;
          if (discType == 1) {
            this.discountFixAmount = discAmt;
            this.discountPercent = "";
          } else if (discType == 2) {
            if (discAmt > 100 && grossTotal > 0) {
              this.discountPercent = (discAmt / grossTotal) * 100;
            } else {
              this.discountPercent = discAmt;
            }
            this.discountFixAmount = "";
          } else {
            this.discountFixAmount = "";
            this.discountPercent = "";
          }
        })
        .catch((error) => {
          this.studentId = null;
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addEditData() {
      this.paymentDetail.push(Vue.util.extend({}, this.editData));
      this.editData = [];
    },

    addData() {
      if (this.editData.item_id) {
        this.paymentDetail.push(Vue.util.extend({}, this.inputData));
      }
    },

    reset() {
      this.addItem = false;
      if (this.editData.item_id != null) {
        this.addEditData();
      }
      this.resetInputData();
    },

    cloneForm() {
      this.editData = [];
      this.addItem = true;
      if (this.$v.inputData.$invalid || this.discountError != "") {
        return;
      }
      if (this.paymentDetail.length < 20) {
        const exists = this.paymentDetail.some(
          (detail) => detail.item_id == this.inputData.item_id,
        );

        if (!exists) {
          this.paymentDetail.push(Vue.util.extend({}, this.inputData));
          this.originalQuantities[this.inputData.item_id] = this.inputData.quantity;
        } else {
          this.$notification.error("Payment Item Is Already Exists.", {
            timer: 3,
            position: "bottomCenter",
          });
        }
        this.resetInputData();
      } else {
        alert("Payment can be created at most 20.");
      }
      this.addItem = false;
    },

    editClone(index) {
        const rowData = { ...this.paymentDetail[index] };
        const savedDiscountAmount = rowData.discount_amount;
        this.addData();
        this.getEditData(rowData);
        this.inputData = {
            ...rowData,
            class_id: this.inputData.class_id,
            student_id: this.inputData.student_id,
            showDiscount: !!rowData.discount_type
        };
        if (!this.inputData.quantity || Number(this.inputData.quantity) < 1) {
            this.inputData.quantity = 1;
        }
        Vue.delete(this.paymentDetail, index);
        this.$nextTick(() => {
            this.inputData.discount_amount = savedDiscountAmount;
            this.calculateNetTotal();
        });
    },

    getEditData(data) {
      this.editData.class_id = data.class_id;
      this.editData.student_id = data.student_id;
      this.editData.guardian1_name = data.guardian1_name;
      this.editData.item_id = data.item_id;
      this.editData.discount_type = data.discount_type;
      this.editData.discount_amount = data.discount_amount;
      this.editData.discount_note = data.discount_note;
      this.editData.gross_total_amt = data.gross_total_amt;
      this.editData.net_total_amt = data.net_total_amt;
      this.editData.quantity = data.quantity;
      if (data.id) {
        this.editData.id = data.id;
      }
    },

    removeClone(index) {
      Vue.delete(this.paymentDetail, index);
      if (this.paymentDetail.length == 0) {
        this.discountPercent = "";
        this.discountPercentageAmount = null;
        this.discountFixAmount = "";
      }
    },

    update() {
      if (this.disabled) return;
      this.submitted = true;

      if (this.paymentDetail.length == 0) {
        this.$notification.error("Payment Item Is Required.", {
          timer: 3,
          position: "bottomCenter",
        });
        return;
      }

      if (this.$v.paymentData.$invalid) {
        this.disabled = false;
        return;
      }

      this.submitting = true;
      this.disabled = true;
      this.isLoading = true;

      const cleanAmount = (val) =>
        val == null ? "0" : String(val).replace(/,/g, "");

      const payload = {
        paymentData: {
          ...this.paymentData,
          gross_total_amt: cleanAmount(this.netTotalSum),
          net_total_amt: cleanAmount(this.amountAfterGlobalDiscount),
          tax: cleanAmount(this.taxAmount),
          grand_total_amt: cleanAmount(this.totalAfterDiscount),
          discount_amount: cleanAmount(this.globalDiscountAmount),
        },
        paymentDetail: this.paymentDetail.map(item => ({
          ...item,
          gross_total_amt: cleanAmount(item.gross_total_amt),
          net_total_amt: cleanAmount(item.net_total_amt),
          discount_amount: cleanAmount(item.discount_amount),
        })),
        loginId: store.state.user.id,
      };

      axios
        .patch(`payment/update/${this.$route.params.invoiceId}`, payload)
        .then((res) => {
          if (res.data && (res.data.success === true || res.data.status === 'success' || res.data === true)) {
            this.$notification.success("Payment Updated Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({
              name: "paymentList",
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          if (error.response && error.response.status == 422) {
            const messages = Object.values(error.response.data.errors)
              .flat()
              .join("\n");
            this.$notification.error(messages, {
              timer: 3,
              position: "bottomCenter",
            });
          }
          this.disabled = false;
        })
        .finally(() => {
          this.isLoading = false;
          this.submitting = false;
          this.disabled = false;
        });
    },

    formatDiscountAmount(amount) {
      return amount ? this.$options.filters.numFormat(amount) : "_";
    },

    checkDiscountType(discount_amount, discount_type) {
      if (discount_amount <= 0) {
        return "_";
      }
      return discount_type == 1 ? "Fixed" : "Percentage";
    },

    getAcademicYears() {
      axios.get("getAcademicYear", {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then((res) => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Academic Year'
        }];
        this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr || res.data);
      }).catch(err => {
        console.error("Error fetching academic years:", err);
        this.academicYearArr = [{ id: 0, text: "Select Academic Year" }];
      });
    },

    getGradesByYear(yearId) {
      this.gradeArr = [{ id: 0, text: "Select Grade" }];
      this.gradeId = "";
      if (!yearId || yearId == 0) return;
      axios
        .get("getGradeNameByAcademicYear", {
          params: { id: yearId, campus_id: this.campusId },
        })
        .then((res) => {
          let $defaultSelectOption = [{ id: 0, text: "Select Grade" }];
          this.gradeArr = $defaultSelectOption.concat(res.data);
        }).catch(err => {
          console.error("Error fetching grades:", err);
        });
    },

    getClassesByGrade(gradeId) {
      this.classArr = [{ id: 0, text: "Select Class" }];
      this.inputData.class_id = "";
      this.inputData.student_id = "";
      this.allStu = [{ id: 0, text: "Select" }];
      if (!gradeId || gradeId == "") return;
      axios
        .get("class/getSection/" + gradeId, {
          params: {
            academic_year: this.academicYearId,
            campus_id: store.state.user.campus_id
          }
        })
        .then((res) => {
          let $defaultSelectOption = [{ id: 0, text: "Select Class" }];
          const data = Array.isArray(res.data[0]) ? res.data[0] : res.data;
          this.classArr = $defaultSelectOption.concat(data);
        }).catch(err => {
          console.error("Error fetching classes:", err);
        });
    },

    getTaxRate() {
      axios.get(`setting/${this.campusId}`)
        .then(res => {
          const raw = parseFloat(res.data?.tax_rate ?? 0);
          this.taxRateValue = Number.isFinite(raw) ? raw / 100 : 0;
        })
        .catch(err => {
          console.log(err);
          this.taxRateValue = CONFIG.TAX_RATE || 0;
        });
    },

    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      // Only allow integers (remove decimal point support)
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
      } else {
          return true;
      }
    },
  },

  watch: {
    "inputData.discount_amount": function (newVal) {
      if (!newVal) {
        this.inputData.net_total_amt = this.inputData.gross_total_amt;
        return;
      }
      let cleanValue = String(newVal).replace(/[^\d.]/g, "");
      if (String(newVal) !== cleanValue) {
        this.inputData.discount_amount = cleanValue;
      }

      let numericVal = parseFloat(cleanValue) || 0;
      let grossTotal = parseFloat(this.inputData.gross_total_amt) || 0;

      if (this.inputData.discount_type == 1) {
        let fixed = Math.min(numericVal, grossTotal);
        this.inputData.net_total_amt = grossTotal - fixed;
      } else if (this.inputData.discount_type == 2) {
        let percent = Math.min(numericVal, 100);
        this.inputData.net_total_amt = grossTotal - (grossTotal * percent / 100);
      }
      if (this.inputData.net_total_amt < 0) this.inputData.net_total_amt = 0;
    },
    "inputData.quantity": function () {
      this.calculateNetTotal();
    },
    discountPercent(val) {
      if (val !== "" && val !== null && this.submitted === false) {
        this.discountFixAmount = "";
      }
    },

    discountFixAmount(val) {
      if (val !== "" && val !== null && this.submitted === false) {
        this.discountPercent = "";
      }
    },

    "inputData.discount_type"() {
      this.inputData.discount_amount = 0;
      this.calculateNetTotal();
    },

    academicYearId() {
      // this.getGradesByYear(val);
    },
    gradeId(val) {
      this.getClassesByGrade(val);
    },
  },

  computed: {
    taxRate() {
      return this.taxRateValue || 0;
    },
    netTotalSum() {
      return this.paymentDetail.reduce(
        (sum, item) => sum + (parseFloat(item.net_total_amt) || 0),
        0,
      );
    },
    globalDiscountAmount() {
      this.paymentDiscountError = "";
      if (this.discountPercent < 0 || this.discountFixAmount < 0) {
        this.paymentDiscountError = "Discount amount cannot be negative.";
      }
      let currentNetTotalSum = this.netTotalSum;
      let discountAmount = 0;
      if (this.discountPercent) {
        if (this.discountPercent > 100) {
          this.discountPercent = 100;
        }
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 2;
        discountAmount = (currentNetTotalSum * this.discountPercent) / 100;
      } else if (this.discountFixAmount) {
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 1;
        discountAmount = Number(this.discountFixAmount);
      } else {
        this.paymentData.is_discount = 0;
        this.paymentData.discount_type = null;
        discountAmount = 0;
      }
      this.paymentData.discount_amount = discountAmount;
      return discountAmount;
    },
    amountAfterGlobalDiscount() {
      let result = this.netTotalSum - this.globalDiscountAmount;
      return result > 0 ? result : 0;
    },
    taxAmount() {
      const tax = Math.round(this.amountAfterGlobalDiscount * this.taxRate);
      this.paymentData.tax = tax;
      return tax;
    },
    totalAfterDiscount() {
      return this.amountAfterGlobalDiscount + this.taxAmount;
    },
    isAddNewFormDisabled() {
      return false;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAcademicYears();
    this.getTaxRate();
    this.getDetail();
  },
};
